import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { Switch } from "@/components/ui/switch"; // یا هر چیزی که خودت داری
import { useDictionary } from "@/core/hooks/use-dictionary";

export default function AvailabilityFilterProduct() {
    const params = useSearchParams();
    const router = useRouter();
    const pathname = usePathname();
    const { dictionary } = useDictionary()

    const available = params.get("is_available") === "1";

    const toggle = () => {
        const newParams = new URLSearchParams(params.toString());

        if (available) {
            newParams.delete("is_available");
        } else {
            newParams.set("is_available", "1");
        }

        router.push(`${pathname}?${newParams.toString()}`);
    };

    return (
        <div className="flex items-center gap-2">
            <span className="text-sm">{dictionary.ui?.product?.available}</span>
            <Switch checked={available} onCheckedChange={toggle} />
        </div>
    );
}
